<div *ngIf="canShow" class="rytmicaction">
  <div *ngIf="false" style="position: relative; top: -25px" class="fs">
    <button (click)="openSettingsWindow()">
      <mat-icon style="position: relative; top: 2px">settings</mat-icon>
    </button>
  </div>
  <div class="fs">
    <div>
      <div class="fs">
        <select
          [ngModel]="strikeService.actionTypeLeft"
          (change)="onChangeLeft($event.target.value)"
          style="position: relative; top: -8px"
        >
          <option [value]="StrikeActionType.CALL">Call</option>
          <option [value]="StrikeActionType.PUT">Put</option>
        </select>
      </div>
      <div class="fs">
        <button
          [ngClass]="{
            activestrikeday: strikeService.actionDayLeft == item.date
          }"
          *ngFor="let item of dates"
          (click)="setLeftDay(item.date)"
        >
          {{ item.day }}
        </button>
      </div>
    </div>
    <div>
      <div class="fs">
        <select
          [ngModel]="strikeService.actionTypeRight"
          (change)="onChangeRight($event.target.value)"
          style="position: relative; top: -8px"
        >
          <option [value]="StrikeActionType.CALL">Call</option>
          <option [value]="StrikeActionType.PUT">Put</option>
        </select>
      </div>
      <div class="fs pt-0">
        <button
          [ngClass]="{
            activestrikeday: strikeService.actionDayRight == item.date
          }"
          *ngFor="let item of dates"
          (click)="setRightDay(item.date)"
        >
          {{ item.day }}
        </button>
      </div>
    </div>
    <div *ngIf="true">
      <span
        #tooltip="matTooltip"
        matTooltip="Display Symbols"
        class="fs"
        (click)="
          strikeSumService.displaySymbols = !strikeSumService.displaySymbols
        "
      >
        <mat-icon *ngIf="strikeSumService.displaySymbols" class="white-icon"
          >check_box</mat-icon
        >
        <mat-icon *ngIf="!strikeSumService.displaySymbols" class="white-icon"
          >check_box_outline_blank</mat-icon
        >
      </span>
      <span
        (click)="
          strikeSumService.displaySymbols = !strikeSumService.displaySymbols
        "
        style="color: #fff; position: relative; top: -7px"
        >Display symbols</span
      >
    </div>
  </div>
</div>
